import { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { Button, Modal, Typography } from '@arkestro/arkestro-design-system';
import { UserContext } from '@providers/UserProvider/UserProvider';
import DeeplinkLoginForm from './DeeplinkLoginForm';
import styles from './DeeplinkLogin.module.scss';

const DeeplinkLogin = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const requestId = router.query.id;
  const [showAuthModal, setShowAuthModal] = useState(false);
  const user = useContext(UserContext);

  const handleOnModalClose = () => {
    setShowAuthModal(false);
  };
  const handleOnModalOpen = () => {
    setShowAuthModal(true);
  };

  const logo = (
    <img
      alt={t('general.logo')}
      className="login-logo"
      height={32}
      src="https://public-assets.arkestro.com/assets/logos/arkestro_logo_color%402x.png"
      width={126}
    />
  );

  return (
    <div className={styles.container}>
      <Typography.Text className={styles.email} ellipsis={{ tooltip: user.email }} strong>
        {user.email}
      </Typography.Text>
      {user.organization_name?.trim() && (
        <Typography.Text className={styles.organization} ellipsis={{ tooltip: user.organization_name }}>
          {user.organization_name}
        </Typography.Text>
      )}
      <Button
        onClick={handleOnModalOpen}
        type="link"
      >
        {t('login.deeplink_login')}
      </Button>

      {showAuthModal &&
          <Modal
            centered
            closeIcon={null}
            destroyOnClose
            footer={null}
            onCancel={handleOnModalClose}
            open
            title={logo}
            width='450px'
          >
            <DeeplinkLoginForm id={requestId} onModalClose={handleOnModalClose} />
          </Modal>
      }
    </div>
  );
};

export default DeeplinkLogin;
